import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import * as analytics from 'analytics/Analytics';
import {IDENTITY_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import ExtractByTypename from 'graphql-client/ExtractByTypename';
import useOnMount from 'ui-library/hooks/useOnMount';
import * as nyc from 'ui-library/NYC';

import {UserPageQuery} from './__generated/UserPageQuery';

type UserPageQueryUser = ExtractByTypename<UserPageQuery['user'], 'UserNode'>;

export interface UserBasicSettingsTabProps {
  user: UserPageQueryUser;
}

export function UserAttribute({label, value}: {label: string; value: string}): JSX.Element {
  return (
    <div className="u-small-padding-top u-small-padding-left">
      <nyc.Row>
        <strong>{label}</strong>
      </nyc.Row>
      <nyc.Row>{value}</nyc.Row>
    </div>
  );
}

export default function UserBasicSettingsTab(props: UserBasicSettingsTabProps): JSX.Element {
  useOnMount(() => {
    analytics.trackEvent(IDENTITY_ANALYTICS_ACTIONS.OPENED_PARTY_BASIC_SETTINGS_TAB, {
      objectType: 'user',
      objectId: props.user.id,
    });
  });
  const attributes: {[key: string]: string} = {
    Name: props.user.name,
    Username: props.user.handle,
    Email: props.user.email,
  };
  return (
    <nyc.Container size="lg" className={css(styles.container)}>
      <nyc.Row>
        <nyc.Col lg={1} />
        <nyc.Col lg={21}>
          {Object.entries(attributes).map(([label, value]: [string, string]) => (
            <UserAttribute key={label} label={label} value={value} />
          ))}
        </nyc.Col>
      </nyc.Row>
    </nyc.Container>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingTop: 20,
    fontSize: 13,
  },
});
